import { useEffect, useReducer } from 'react';
import { getNotification } from '../utils/InnerApi';

export function useGetNotification(limit, lang) {
  const [{ data, complete, error }, dispatch] = useReducer(
    (state, action) => {
      switch (action.type) {
        case 'loading':
          return { data: null, complete: false, error: null };
        case 'result':
          return { data: action.data, complete: true, error: null };
        case 'error':
          return { data: null, complete: true, error: action.error };
        default:
          return {};
      }
    },
    {
      data: null,
      complete: false,
      error: null
    }
  );
  function reload() {
    if (complete) dispatch({ type: 'loading' });
    getNotification(limit, lang)
      .then((data) => dispatch({ type: 'result', data }))
      .catch((error) => dispatch({ type: 'error', error }));
  }
  useEffect(() => {
    reload();
    return () => dispatch({ type: 'loading' });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return { data, complete, error, reload };
}
